// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MenuItens_PegaItensDoMenuPermitidosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /config/menu_itens/pega_itens_do_menu_permitidos.
 *
 * Returns the list of active menu items the current user's groups are
 * permitted to see, ordered by menu_item_ordem.
 */
import type { MenuItens_PegaItensDoMenuPermitidosRow } from './MenuItens_PegaItensDoMenuPermitidosRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type MenuItens_PegaItensDoMenuPermitidosResponseDados = MenuItens_PegaItensDoMenuPermitidosRow[];

export type MenuItens_PegaItensDoMenuPermitidosResponse = ApiResponse<MenuItens_PegaItensDoMenuPermitidosResponseDados>;

registerResponseContract('MenuItens_PegaItensDoMenuPermitidosResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      menu_item_id:         { type: 'number',  required: true },
      menu_item_titulo:     { type: 'string',  required: true },
      menu_item_tipo:       { type: 'string',  required: true },
      menu_item_icone:      { type: 'string',  required: true },
      menu_item_controller: { type: 'string',  required: true },
      menu_item_pai_id:     { type: 'string',  required: true },
      menu_item_status:     { type: 'number',  required: true },
      menu_item_ordem:      { type: 'number',  required: true },
      menu_item_permissoes: { type: 'string',  required: true },
      menu_item_url:        { type: 'string',  required: true },
    },
  },
})
